import { Badge as ChakraBadge, BadgeProps } from '@chakra-ui/react';
import React from 'react';

// Exports
export const Badge = ({ children, ...restProps }: BadgeProps) => {
  return (
    <ChakraBadge
      as="div"
      display="flex"
      variant="subtle"
      height="30px"
      alignItems="center"
      justifyContent="center"
      p="0 10px"
      {...restProps}
    >
      {children}
    </ChakraBadge>
  );
};
